import React, { FC } from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

interface IProductCardListSkeletonProps {
  hasFooter?: boolean;
}

export const ProductSkeleton = () => {
  return (
    <Box style={styles.productSkeletonContainer}>
      <Box style={styles.productSkeletonRow}>
        <Skeleton rounded={12} w="$24" h="$20" />
        <Box style={styles.productSkeletonDetails}>
          <Skeleton rounded="full" h="$5" />
          <Box style={styles.productSkeletonMetaRow}>
            <Skeleton rounded="full" h="$5" flex={3} />
            <Skeleton rounded="full" h="$5" flex={1} mr="$12" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const ProductCardListSkeleton: FC<React.PropsWithChildren<
  IProductCardListSkeletonProps
>> = ({ hasFooter }) => {
  return (
    <Box style={styles.productCardListSkeleton}>
      <Box style={styles.productCardHeaderRow}>
        <Skeleton rounded="full" flex={5} h="$5" />
        <Skeleton rounded="full" h="$9" flex={2} startColor="#D623004D" endColor="#D623001A" />
      </Box>
      <ProductSkeleton />
      {hasFooter && (
        <Box style={styles.footerSkeletonRow}>
          <Skeleton rounded="full" h="$4" flex={2} />
          <Skeleton rounded="full" h="$4" flex={5} />
        </Box>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  footerSkeletonRow: {
    flexDirection: 'row',
    gap: spacing.$2,
    marginTop: spacing.$3,
    width: spacing.$20,
  },
  productCardHeaderRow: {
    flexDirection: 'row',
    gap: spacing.$10,
    marginTop: spacing.$3,
  },
  productCardListSkeleton: {
    marginTop: spacing.$4,
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
  productSkeletonContainer: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  productSkeletonDetails: {
    flex: 1,
    gap: spacing.$2,
    justifyContent: 'center',
    paddingRight: spacing.$4,
  },
  productSkeletonMetaRow: {
    flexDirection: 'row',
    gap: spacing.$2,
  },
  productSkeletonRow: {
    flex: 1,
    flexDirection: 'row',
    gap: spacing.$4,
    marginTop: spacing.$3,
  },
});
